export const convertCatalogNameToReadableId = (name?: string | number): string => {
    if (!name) {
        return "";
    }
    return `${name}`.toLowerCase()
        .replaceAll(" - ", "-")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll(" ", "-");
};